if ($("header#header").length) {

    if ($('#footer .infoLine')) {
        $('.header-top').after($('#footer .infoLine').clone());
    }


    if (!$('#cart-widget .emptyCart').length) {
        $('#cart-widget').append($('#footer .emptyCart'));
    }
    if (!$('#cart-widget .primaryCategories').length) {
        $('#cart-widget').append($('#footer .primaryCategories').clone());
    }

    if (!$('a.cart-count i[data-testid="headerCartCount"]').length) {
        $('a[data-target="cart"]').append('<i data-testid="headerCartCount">0</i>')
    }

    $(".search-input").attr("placeholder", "Co hledáte… např. Windows 11, Office 2024");

    $(".header-top").append($(".top-navigation-bar .responsive-tools").clone());
    $(".header-top .responsive-tools").prepend($(".top-navigation-tools .dropdown").clone());
    $('.navigation-buttons a[data-target="cart"]').clone().appendTo(".header-top .responsive-tools");
    $('.top-navigation-tools').append('<a href="/registrace">Registrovat se</a>');

    $('<span class="close"></span>').appendTo(
        ".login-widget .popup-widget-inner #customerLogin",
    );

    $('.header-top').append("<div class='superContact'></div>");
    $('.header-top .superContact').append($("footer#footer .contact-box li span.tel").closest("li").clone().addClass("tel"));
    $(".header-top span.tel").append(`<span class="info">${telefonInfo}</span>`)

    $('.header-top .responsive-tools').append($('.header-top .site-name-wrapper').clone());
    $(document).on(
        "click",
        ".login-widget .popup-widget-inner .close",
        function () {
            $("body").removeClass("user-action-visible login-window-visible");
        },
    );
    $(document).ready(function () {
        let target = 'cart';
        let timeout;
        const $cartHoverArea = $('a[data-target="cart"]');
        $cartHoverArea.on('mouseenter', function () {
            var show = (target === 'cart' && !$('a[data-target="cart"]').hasClass('full')) ? false : true;
            shoptet.popups.showPopupWindow(target, show);
        });
    });

}



